import { downloadFileFromUrl } from '@gap/utils/file/download-file'
import { FileShareRouterTypes } from '@trpc-endpoints/trpc-public/routers/file-share-router'
import { apiPublicClientSilent } from 'api/trpc-public/trpc-client'
import { observer } from 'mobx-react-lite'
import { useParams } from 'react-router-dom'
import { PlatformContainer } from 'reusable/containers/PlatformContainer'
import useInitialMount from 'reusable/hooks/useInitialMount'
import useStore from 'reusable/mobx-store-utils'

export default observer(function AuthShareFile() {
   const { token } = useParams()

   const authShareFileStore = useStore(sp => ({
      status: 'loading' as FileShareRouterTypes.StatusType | 'loading' | 'unknown-error',
      get tokenIsValid() {
         return sp.token && sp.token.length === 40
      },
      get statusMessage() {
         switch (authShareFileStore.status) {
            case 'loading':
               return 'Getting your file ready...'
            case 'error':
               return `Something went wrong${!authShareFileStore.tokenIsValid && '. Please ensure the url is correct and try again'}`
            case 'expired-token':
               return 'This link has expired. Please request a new link from your advisor'
            case 'success':
               return 'Your file download should start automatically. You can now close this window'
            case 'unknown-error':
               return 'Something went wrong. Please try again or contact support if the issue persists'
         }
      },
      load: async () => {
         const fileInfo = await apiPublicClientSilent.fileShare.getFileBasedOnToken.query({ token: sp.token! })
         authShareFileStore.status = fileInfo.status

         if (fileInfo.status === 'success') {
            if (!fileInfo.link) {
               authShareFileStore.status = 'unknown-error'
               return
            }
            downloadFileFromUrl(fileInfo.link, fileInfo.asFileName)
         }
      }
   }), { token })

   useInitialMount(() => {
      if (authShareFileStore.tokenIsValid) {
         authShareFileStore.load()
      } else {
         authShareFileStore.status = 'error'
      }
   })

   return <PlatformContainer contentCentered={true}>
      {authShareFileStore.statusMessage}
   </PlatformContainer>
})
